import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { label: 'Place Your Picks Here', path: '/picks' },
  { label: "All Players' Picks Page", path: '/allpicks' },
  { label: 'The Spread by Week', path: '/spread' },
  { label: 'Weekly Scores', path: '/weekly-scores' },
  { label: 'Player Roster & Payments', path: '/roster-payments' },
  { label: 'Administration Tools', path: '/admin-tools' },
  { label: 'Rules', path: '/rules' },
  { label: 'Chat', path: '/chat' },
  { label: 'The Pot', path: '/pot' },
  { label: 'Leaderboard', path: '/leaderboard' }
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div style={{ padding: 20 }}>
      <h1 style={{ fontSize: 26, marginBottom: 20 }}>
        Welcome to the Football Pick&apos;em Game
      </h1>

      <div style={{ marginBottom: 20, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {tabs.map(({ label, path }) => {
          const active = pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              style={{
                padding: '8px 12px',
                border: active ? '2px solid #0a7' : '1px solid #333',
                background: active ? '#e7fff3' : '#fff',
                borderRadius: 4,
                cursor: 'pointer'
              }}
            >
              {label}
            </button>
          );
        })}
      </div>

      <div>{children}</div>
    </div>
  );
}
